import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import configMenu from '../configMenu.vue';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { isEmpty, guid } from '@/utils';
import { getPictureByKey } from '@/views/custom-layout/api';
export default {
  name: 'goods_nav_config',
  components: {
    draggable: draggable,
    configMenu: configMenu,
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    parentKey: String,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object
  },
  data: function data() {
    return {
      typeList: [],
      menusMap: {},
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      updateIndex: 0,
      depot: {},
      defaultValue: {
        imageurl: 'https://res.youlianfuwu.com/mini_program/shop/list_placeholder.png',
        link_type: '1',
        link_value: '',
        goods_id: '',
        module_plate_id: '',
        sort: ''
      }
    };
  },
  methods: {
    // 仅允许数字和小数点，且只保留 1 位小数（通过先暂存首个小数点再清除其余小数点实现）
    onTagDiscountInput: function onTagDiscountInput(val) {
      var v = String(val).replace(/[^\d.]/g, '').replace('.', '#').replace(/\./g, '').replace('#', '.').replace(/^(\d*\.\d).*/, '$1');
      this.value.config.tag_discount = v;
    },
    // 校验折扣范围：0 至 9.9，支持 1 位小数
    checkTagDiscount: function checkTagDiscount(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        return callback(new Error('折扣不可为空'));
      }
      // 输入框可能为字符串，做一次归一化
      var num = Number(value);
      if (Number.isNaN(num)) {
        return callback(new Error('折扣必须为数字'));
      }
      if (num < 0 || num > 9.9) {
        return callback(new Error('折扣范围为 0 至 9.9 折'));
      }
      // 限制 1 位小数
      var strVal = String(value);
      var dotIndex = strVal.indexOf('.');
      if (dotIndex > -1 && strVal.length - dotIndex - 1 > 1) {
        return callback(new Error('折扣仅支持 1 位小数'));
      }
      callback();
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.ads[this.updateIndex]['imageurl'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      this.$refs.uploadBanner[index].uploadBanner();
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.imageurl = "".concat(this.$ossurl).concat(res);
    },
    changeType: function changeType(item) {
      this.value.config.show_type = item.id;
      this.value.config.is_open_ad = item.id === 2 ? '0' : this.value.config.is_open_ad;
      this.value.config.ads.forEach(function (i) {
        return i.imageurl = '';
      });
    },
    checkNumber: function checkNumber(rule, value, callback) {
      if (value === '') {
        return callback('商品展示行数不可为空');
      } else {
        if (!/^[0-9]*$/.test(value)) {
          callback('仅支持正整数');
        } else if (value > 199 || value < 1) {
          callback('仅支持1-199正整数');
        } else {
          callback();
        }
      }
    },
    changeSwitch: function changeSwitch() {
      this.$refs.form.validate();
    },
    checkList: function checkList(type, value, callback, flag) {
      if (flag && isEmpty(value)) {
        callback("".concat(type === 'sub_name' ? '副标题' : '展示名称', "\u4E0D\u53EF\u4E3A\u7A7A"));
      }
      if (this.value.config.value.some(function (i) {
        return i.flag == true;
      })) {
        callback();
      } else {
        callback('请给要展示的分类选择菜单');
      }
    },
    changeCategory: function changeCategory(val) {
      if (val) {
        var menu = this.menusMap[val] || [];
        var children = menu.map(function (i) {
          return _objectSpread(_objectSpread({}, i), {}, {
            primitiveName: i.name,
            sub_name: '',
            flag: true
          });
        });
        this.value.config.value = children || [];
      } else {
        this.value.config.value = [];
      }
    },
    buildChildrenMap: function buildChildrenMap(arr) {
      var map = {};
      function recurse(items) {
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            map[item.id] = item.childrens || [];
            if (item.childrens && item.childrens.length > 0) {
              recurse(item.childrens);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      recurse(arr);
      return map;
    }
  },
  created: function created() {
    var _this$tabListFlat$fin,
      _this2 = this;
    this.getPicture();
    var _ref = ((_this$tabListFlat$fin = this.tabListFlat.find(function (i) {
        return i.key === _this2.value.key;
      })) === null || _this$tabListFlat$fin === void 0 ? void 0 : _this$tabListFlat$fin.config_default_value) || {},
      _ref$typeList = _ref.typeList,
      typeList = _ref$typeList === void 0 ? [] : _ref$typeList;
    this.typeList = typeList;
    var _this$value$config = this.value.config,
      _this$value$config$va = _this$value$config.value,
      value = _this$value$config$va === void 0 ? [] : _this$value$config$va,
      _this$value$config$is = _this$value$config.is_open_ad,
      is_open_ad = _this$value$config$is === void 0 ? '0' : _this$value$config$is,
      _this$value$config$ta = _this$value$config.tag_discount,
      tag_discount = _this$value$config$ta === void 0 ? 9.5 : _this$value$config$ta,
      _this$value$config$ta2 = _this$value$config.tag_discount_text,
      tag_discount_text = _this$value$config$ta2 === void 0 ? '立省' : _this$value$config$ta2,
      _this$value$config$ta3 = _this$value$config.tag_no_discount_text,
      tag_no_discount_text = _this$value$config$ta3 === void 0 ? '超值好物' : _this$value$config$ta3,
      _this$value$config$ta4 = _this$value$config.tag_btn_text,
      tag_btn_text = _this$value$config$ta4 === void 0 ? '抢' : _this$value$config$ta4;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({
      category_id: '',
      sort: '3',
      line_number: 5,
      list_show_type: 1,
      //列表展示样式 1-固定行数商品 2-上滑无限加载商品
      list_show_more: 1,
      //是否显示加载更多 0-不显示 1-显示,
      show_type: this.value.show_type || 1,
      // 兼容新老组件 默认预置类型为图片是图
      is_open_sub_name: '0',
      //兼容新老组件 默认预置关闭
      is_show_title: 1,
      //兼容新老组件 默认预置显示
      margin_top: 15,
      //兼容新老组件 默认预置15px
      z_index: 2,
      //兼容新老组件 默认预置2
      is_open_ad: is_open_ad,
      ads: [_objectSpread(_objectSpread({}, this.defaultValue), {}, {
        uid: guid()
      })],
      // 价签标签配置（show_type = 4 时使用）
      tag_discount: tag_discount,
      tag_discount_text: tag_discount_text,
      tag_no_discount_text: tag_no_discount_text,
      tag_btn_text: tag_btn_text
    }, this.value.config), {}, {
      value: value.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          sub_name: i.sub_name || '' // 后增加属性,预防之前老组件在某些机型上因为新增属性无法实现响应式
        });
      })
    }));
  },
  computed: {
    menuListFilter: function menuListFilter() {
      var menus_entity = this.menuList.filter(function (i) {
        return ['entity', 'new_entity'].includes(i.type);
      });
      this.menusMap = this.buildChildrenMap(menus_entity); // 以id为键 列出childrens枚举
      return this.parentKey ? menus_entity : menus_entity.map(function (parent) {
        return _objectSpread(_objectSpread({}, parent), {}, {
          childrens: parent.childrens ? parent.childrens.map(function (child) {
            child = JSON.parse(JSON.stringify(child)); // 深拷贝，避免修改原数据
            child.hasOwnProperty('childrens') && delete child.childrens; // 只保留到二级
            return _objectSpread({}, child);
          }) : []
        });
      });
    }
  }
};